import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import classnames from 'classnames';
import { ApolloProvider, Mutation } from 'react-apollo';
import gql from 'graphql-tag';

import {
  ORDER_NO_VOUCHER,
} from '@arreeba/ristoranti-frontend-lib/lib/constants';
import {
  cartSelector,
} from '@arreeba/ristoranti-frontend-lib/lib/selectors/cart';
import VoucherHelpers from '@arreeba/ristoranti-frontend-lib/lib/helpers/voucher';
import I18N from '@arreeba/ristoranti-frontend-lib/lib/helpers/i18n';

import ButtonsContainer from '../../components/buttonsContainer';
import BackButton from '../../components/back-button';
import Button from '../../components/button';
import List from '../../components/list';
import CartTotal from '../../components/cart/cart-total';
import { connect } from '../../util';
import Url from '../../lib/url';
import { userRequired } from '../user/';
import { COMMON_LOCALIZED } from '../../lib/localized';

const VALIDATE_PROMO_CODE = gql`
  mutation CreateVoucherInstance(
    $promoCode: String!,
    $app: ID!,
    $amount: Int!,
    $orderType: OrderType!
  ) {
    createVoucherInstance (promoCode: $promoCode, app: $app, amount: $amount, orderType: $orderType) {
      id
      instance {
        id
      }
    }
  }
`;

const getPromoCodeTreshold = (error) => {
  return parseInt(error.toString().split('€')[0].slice('-2'), 10);
};

const getPromoCodeErrorMessage = (error) => {
  const errorMessage = error.toString();
  let result = 'Il codice sconto non è valido';
  if (errorMessage.includes('This promo code requires a higher order amount')) {
    result = `Per applicare questo codice sconto devi raggiungere un importo minimo di ${getPromoCodeTreshold(error)}€`;
  }
  if (errorMessage.includes('Invalid promo code for this kind of order')) {
    result = 'Il codice sconto inserito non è valido per questo tipo di ordine';
  }
  return result;
};

class OrderVoucher extends React.Component {
  constructor(props) {
    super(props);
    this.goToCheckout = this.goToCheckout.bind(this);
    this.selectVoucher = this.selectVoucher.bind(this);
    this.state = { promoCode: '' };
  }

  goToCheckout() {
    browserHistory.push(Url.orderCheckout({ ...this.props.url }));
  }

  selectVoucher(data) {
    const voucherId = (data.id !== ORDER_NO_VOUCHER) ? data.instance.id : ORDER_NO_VOUCHER;
    this.props.actions.order.addVoucher(voucherId);
  }

  render() {
    const data = this.props.cartData;
    const app = this.props.app;

    if (data && data.vouchers) {
      const noVouchers = data.vouchers.length === 1 && data.vouchers[0].id === ORDER_NO_VOUCHER;

      if (noVouchers && !app.config.modules.promoCode.active) {
        this.goToCheckout();
        return null;
      }
    }
    const language = I18N.currentLanguage('it'); // TODO replace with current language
    return (
      <ApolloProvider client={this.props.apolloClient}>
        <main>
          <div>
            <p>
              Hai accumulato dei buoni sconto di cui puoi usufruire ora, se vuoi.
            </p>
            <p>
              Scegli quello che vuoi usare, o seleziona
              "Nessuno sconto" per usufruirne al prossimo ordine!
            </p>
          </div>
          <div className="voucherList">
            <List>
              {data && data.vouchers &&
                data.vouchers.map((voucher, i) => {
                  const selectedId = this.props.selectedVoucher;
                  const isNoVoucher = !voucher.instance && selectedId === ORDER_NO_VOUCHER;
                  const isRealVoucher = voucher.instance &&
                    voucher.instance.id === selectedId;
                  const isSelected = isNoVoucher || isRealVoucher;
                  const classes = classnames({
                    'voucherList__element--selected': isSelected,
                  });
                  return (
                    <li key={voucher.id + i} className={classes}>
                      <button
                        className="voucherList__element"
                        onClick={() => this.selectVoucher(voucher)}
                      >
                        <div>
                          <p>{voucher.message}</p>
                          {voucher.discount &&
                            <span className="voucherList__elementDiscount accent">
                              Sconto {VoucherHelpers.format(voucher, COMMON_LOCALIZED, language).subtitle}
                            </span>
                          }
                        </div>
                        {isSelected && <span className="voucherList__selected">✓</span>}
                      </button>
                    </li>
                  );
                })
              }
            </List>
            {this.props.app.config.modules.promoCode &&
              this.props.app.config.modules.promoCode.active &&
              <Mutation
                mutation={VALIDATE_PROMO_CODE}
                onCompleted={(data) => {
                  this.props.services.voucher.getMine(this.props.actions.voucher).then(
                    () => this.props.actions.order.addVoucher(data.createVoucherInstance.instance.id)
                  );
                }}
              >
                {(validatePromoCode, { error }) => (
                  <div className="promoCodeForm">
                    <p className="promoCodeForm__title">Se possiedi un codice sconto inseriscilo qui:</p>
                    {error &&
                      <p className="promoCodeForm__title promoCodeForm__error">
                        {getPromoCodeErrorMessage(error)}
                      </p>
                    }
                    <form
                      className="promoCodeForm__form"
                      onSubmit={(e) => {
                        e.preventDefault();
                        if (this.state.promoCode) {
                          validatePromoCode({ variables: {
                            promoCode: this.state.promoCode,
                            app: this.props.app.id,
                            amount: data.total,
                            orderType: this.props.url.orderType.toUpperCase(),
                          } });
                          this.setState({ promoCode: '' });
                        }
                      }}
                    >
                      <input
                        type="text"
                        className="promoCodeForm__input"
                        value={this.state.promoCode}
                        onChange={(e) => {
                          this.setState({ promoCode: e.target.value });
                        }}
                      />
                      <button
                        type="submit"
                        className="btn-submit promoCodeForm__submit"
                      >
                        applica
                      </button>
                    </form>
                  </div>
                  )
                }
              </Mutation>}
            <CartTotal
              total={data.total}
              subtotal={data.subtotal}
              extraCosts={data.extraCosts}
            />
          </div>
          <ButtonsContainer>
            <BackButton />
            <Button
              type="next"
              text="CONTINUA"
              onClick={this.goToCheckout}
            />
          </ButtonsContainer>
        </main>
      </ApolloProvider>
    );
  }
}

OrderVoucher.propTypes = {
  selectedVoucher: PropTypes.oneOfType([
    PropTypes.string, PropTypes.number,
  ]),
};

const mapStateToProps = (state, props) => ({
  selectedVoucher: state.order.selectedVoucher,
  cartData: cartSelector(COMMON_LOCALIZED)(state, props),
});

export default userRequired(connect(OrderVoucher, { mapStateToProps }));



// WEBPACK FOOTER //
// ./src/containers/order/order-voucher.js